import { AutoDeskIntegrationTypeEnum } from 'api/enums';
import { ICameraModel } from './camera.model';
import { IClientModel } from './client.model';
import { IUserModel } from './user.model';
import { immerable } from 'immer';

/* -------------------------------------------------------------------------------------------------
 * IAutodeskIntegrationModel
 * -----------------------------------------------------------------------------------------------*/
export interface IAutodeskIntegrationModel {
    _id: string;
    client: IClientModel;
    user: IUserModel;
    camera: ICameraModel;
    token: string;
    type: AutoDeskIntegrationTypeEnum;
    refreshInterval: number;
    options: {
        showTimestamp?: boolean;
        showCameraName?: boolean;
        showProjectName?: boolean;
        showZoomed?: boolean;
        customText?: string;
    };
    // imageUpdateFrequency?: number;
}

/* -------------------------------------------------------------------------------------------------
 * AvailablePluginModel
 * -----------------------------------------------------------------------------------------------*/
export class AutodeskIntegrationModel {
    [immerable] = true;

    _id: string;
    client: IClientModel;
    user: IUserModel;
    camera: ICameraModel;
    token: string;
    type: AutoDeskIntegrationTypeEnum;
    refreshInterval: number;
    options: {
        showTimestamp?: boolean;
        showCameraName?: boolean;
        showProjectName?: boolean;
        showZoomed?: boolean;
        customText?: string;
    };
    // imageUpdateFrequency?: number;

    constructor(data: Partial<IAutodeskIntegrationModel>) {
        this._id = data._id;
        this.client = data.client;
        this.user = data.user;
        this.camera = data.camera;
        this.token = data.token;
        this.type = data.type;
        this.refreshInterval = data.refreshInterval;
        // this.imageUpdateFrequency = data.imageUpdateFrequency;

        this.options = {
            showTimestamp: data.options?.showTimestamp,
            showCameraName: data.options?.showCameraName,
            showProjectName: data.options?.showProjectName,
            showZoomed: data.options?.showZoomed,
            customText: data.options?.customText || '',
        };
    }

    static fromObject(data: Partial<IAutodeskIntegrationModel>): AutodeskIntegrationModel {
        const model = new AutodeskIntegrationModel(data);

        return model;
    }

    static cloneFrom(data: Partial<IAutodeskIntegrationModel>): AutodeskIntegrationModel {
        const model = new AutodeskIntegrationModel(data);

        return model;
    }

    static fromObjectList(data: Partial<IAutodeskIntegrationModel>[]): AutodeskIntegrationModel[] {
        return data.map((row) => AutodeskIntegrationModel.fromObject(row));
    }

    toObject(): IAutodeskIntegrationModel {
        const data: Partial<IAutodeskIntegrationModel> = {
            _id: this._id,
            client: this.client,
            user: this.user,
            camera: this.camera,
            token: this.token,
            type: this.type,
            refreshInterval: this.refreshInterval,
            // imageUpdateFrequency: this.imageUpdateFrequency,
            options: {
                showTimestamp: this.options.showTimestamp,
                showCameraName: this.options.showCameraName,
                showProjectName: this.options.showProjectName,
                showZoomed: this.options.showZoomed,
                customText: this.options.customText,
            },
        };

        return data as IAutodeskIntegrationModel;
    }
}
